// extracted by css-extract-rspack-plugin
export default {"Box":"SubIssueAddedEvent-module__Box__MeKru","Box_1":"SubIssueAddedEvent-module__Box_1__fM3Nh"};